import { render } from "./forgetPass.vue?vue&type=template&id=34ff0dc6"
import script from "./forgetPass.vue?vue&type=script&lang=js"
export * from "./forgetPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__